'use strict';

angular.module('internal.licenses')
    .controller('InternalLicenseTriggers', ['$scope', '$stateParams', 'TriggerCategories', 'TriggerConfigurationTriggers', '$q', '$uibModal', function ($scope, $stateParams, TriggerCategories, TriggerConfigurationTriggers, $q, $uibModal) {
        $scope.resetLicense();
        $scope.triggerConfigurationID = $stateParams.triggerConfigurationID;
        $scope.triggerConfiguration = $stateParams.trigger_configuration;
        $scope.editMode = false;

        $scope.determineWidth = function (index, length) {
            var value = Math.floor(12 / length);
            var mod = 12 % length;
            if (index < mod) {
                value += 1;
            }
            if (value <= 2) {
                value = 3;
            }
            return 'col-xs-' + value;
        }

        $scope.checkInfinite = function (trigger) {
            if (trigger != null && trigger.infiniteFound) {
                $scope.infiniteFound = true;
            }
        }

        $scope.openCategoryModal = function (trigger_configuration_id, trigger_category, trigger) {
            //'initial_trigger_categories' keeps the initial state of trigger categories. When the modal closes, any changes will be reset.
            $scope.initial_trigger_categories = angular.copy($scope.trigger_categories);

            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: paths.app + 'licenses/components/trigger-category-modal/trigger-category-modal.html',
                controller: 'InternalTriggerCategoryModal',
                size: 'xl',
                resolve: {
                    trigger_configuration_category: function () {
                        return trigger_category;
                    },
                    trigger_configuration_trigger: function () {
                        return trigger != null ? trigger.object : null;
                    },
                    trigger_configuration_id: function () {
                        return trigger_configuration_id;
                    },
                    licenseID: function () {
                        return $scope.licenseID;
                    }
                }
            });

            modalInstance.result.then(function (newTCT) {
                if (newTCT.trigger_id == null) {
                    //deleted; remove it from the model
                    var index = trigger_category.trigger_configuration_triggers.map(function (e) { return e.id }).indexOf(newTCT.id);
                    if (index >= 0) {
                        trigger_category.trigger_configuration_triggers.splice(index, 1);
                    }
                } else {
                    if (trigger) {
                        // modified; update the existing trigger configuration
                        trigger.object = newTCT;

                        if (trigger.object.actions.length == 0) {
                            updateArray(trigger_category.trigger_configuration_triggers, trigger, true);
                        }
                    } else {
                        // added; add to array
                        trigger_category.trigger_configuration_triggers.push({
                            id: newTCT.id,
                            focus: false,
                            object: newTCT
                        });
                    }
                }
            }, function () {
                    //Reset all the changes made from the users:
                    $scope.trigger_categories = angular.copy($scope.initial_trigger_categories);
            });
        }

        $scope.openHistoryModal = function (trigger) {
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: paths.app +
                    'licenses/components/trigger-category-modal/trigger-category-history-modal.html',
                controller: 'InternalTriggerCategoryHistoryModal',
                size: 'xl',
                resolve: {
                    trigger_configuration_trigger_id: function () {
                        return trigger.id;
                    }
                }
            });
        }

        $scope.triggerHover = function (trigger, action) {
            $scope.trigger_categories.forEach(function (category) {
                if (category.name == 'Form Submission') {
                    category.trigger_configuration_triggers.forEach(function (trigger) {
                        trigger.object.focus = false;
                    })
                }
            })

            if (!(action.name == 'Form' || action.name == 'Form Package')) {
                return;
            }

            trigger.form_packages.forEach(function (formPackage) {
                formPackage.forms.forEach(function (form) {
                    $scope.trigger_categories.forEach(function (category) {
                        if (category.name == 'Form Submission') {
                            category.trigger_configuration_triggers.forEach(function (trigger) {
                                if (trigger.object.name == 'Form Completed: ' + form.name) {
                                    trigger.object.focus = true;
                                }
                            })
                        }
                    })
                })
            })

            trigger.forms.forEach(function (form) {
                $scope.trigger_categories.forEach(function (category) {
                    if (category.name == 'Form Submission') {
                        category.trigger_configuration_triggers.forEach(function (trigger) {
                            if (trigger.object.name == 'Form Completed: ' + form.name) {
                                trigger.object.focus = true;
                            }
                        })
                    }
                })
            })
        }

        $scope.triggerLeave = function (trigger, action) {
            if (!(action.name == 'Form' || action.name == 'Form Package')) {
                return;
            }

            $scope.trigger_categories.forEach(function (category) {
                if (category.name == 'Form Submission') {
                    category.trigger_configuration_triggers.forEach(function (trigger) {
                        trigger.focus = false;
                    })
                }
            })
        }

        if ($scope.triggerConfigurationID != null) {
            $scope.loading = true;

            var a = TriggerCategories.get($scope.triggerConfigurationID);

            var b = TriggerConfigurationTriggers.get($scope.triggerConfigurationID, true);

            $q.all([a, b]).then(function (data) {
                var promises = [];
                $scope.trigger_categories = data[0];
                var noCategoryTriggers = data[1];

                $scope.trigger_categories.forEach(function (category) {
                    if (category.name == "Approval Process") {
                        category.trigger_configuration_triggers = category.trigger_configuration_triggers.concat(noCategoryTriggers);
                    }

                    category.trigger_configuration_triggers.forEach(function (trigger, index, object) {
                        promises.push(TriggerConfigurationTriggers.getByIDWithActions(trigger.id, null, $scope.licenseID).then(function (tct) {
                            if (tct.actions.length > 0) {
                                trigger.object = tct;
                                trigger.remove = false;
                            }
                            else {
                                trigger.remove = true;
                            }
                        }));
                    })
                })

                $q.all(promises).then(function () {
                    $scope.trigger_categories.forEach(function (category) {
                        category.trigger_configuration_triggers.slice().reverse().forEach(function (trigger, index, object) {
                            if (trigger.remove) {
                                category.trigger_configuration_triggers.splice(object.length - 1 - index, 1);
                            }
                        })
                    })

                    $scope.loading = false;
                }).catch(function (response) {
                    // handle error
                });
            }).catch(function (response) {
                // handle error
            });
        }
    }])

